/**
 * Corporate Theme - Main Entry Point
 * Focused on high-performance Vanilla JS and GSAP animations.
 */

// 1. Global Styles
import "../scss/style.scss";

// 2. Image Optimization (Lazysizes)
import "lazysizes";
import "lazysizes/plugins/rias/ls.rias";
import "lazysizes/plugins/parent-fit/ls.parent-fit";

// 3. Animation Engine
import { initScrollAnimations } from "./common/animation/scrollAnimations";

// 4. Prefetching
import { listen } from "quicklink";

// 5. Header & Navigation
import { initHeader } from "./parts/header/header";
import { initMobileMenuOffcanvas } from "./parts/header/mobileMenu";
import { initLanguageSwitcher } from "./parts/header/languageSwitcher";
import { initSearchModal } from "./parts/header/search";

// 6. Page Content Partials
import { initArchiveMasonry } from "./partials/PageContent/default/archiveMasonry";
import { initArchiveShowcaseVideos } from "./partials/PageContent/default/archiveShowcase";
import { initArticleWSlider } from "./partials/PageContent/default/articleWSlider";
import { initCtaImageParallax } from "./partials/PageContent/default/ctaImage";
import { initCtaSlider } from "./partials/PageContent/default/ctaSlider";
import { initHeroBento } from "./partials/PageContent/default/heroBento";
import { initHeroSlider } from "./partials/PageContent/default/heroSlider";
import { initCategoryDropdown } from "./partials/PageContent/default/categoryDropdown";

// 7. Post Content Partials
import { initWysiwyg } from "./partials/PostContent/default/wysiwyg";
import { initTableOfContents } from "./partials/PostContent/default/tableOfContents";
import { initPostMetaViewCount } from "./partials/PostContent/default/postMeta";
import { initCommentForm } from "./partials/PostContent/default/comments/commentForm";

// 8. Forms
import { initLawyerContactForm } from "./common/forms/lawyerContactForm";
import { initContactForm } from "./templates/contact/contactForm";

// 9. Footer & Cookie Consent
import { initCookieConsent } from "./parts/footer/cookieConsent";
import { initStickyContactBar } from "./parts/footer/stickyContactBar";

/**
 * Initialize all global and component-specific logic.
 */
const initGlobals = () => {
  // Initialize Scroll-Triggered Animations (GSAP)
  initScrollAnimations();

  // Parts Initializers
  initHeader();
  initMobileMenuOffcanvas();
  initLanguageSwitcher();
  initSearchModal();

  // --- Page Content Partials Initializers ---
  initArchiveMasonry();
  initArchiveShowcaseVideos();
  initArticleWSlider();
  initCtaImageParallax();
  initCtaSlider();
  initHeroBento();
  initHeroSlider();
  initCategoryDropdown();

  // --- Post Content Initializers ---
  initWysiwyg();
  initTableOfContents();
  initPostMetaViewCount();
  initCommentForm();

  // --- Forms Initializers ---
  initLawyerContactForm();
  initContactForm();

  // --- Footer Initializers ---
  initCookieConsent();
  initStickyContactBar();

  // Start listening for in-viewport links to prefetch
  listen();

  console.log("[Main JS] Corporate Base initialized completely.");
};

// --- Bootstrap ---
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initGlobals);
} else {
  initGlobals();
}
